interface ISalary {
	id: number;
	employeeId: number;
	reportType: number;
	reportDate: Date;
	status: number;
	emailTaskId: string;
	sendingDate: Date;
	fileUploadId: string | null;
	system: string;
}

export class Salary implements ISalary {
	id: number;
	employeeId: number;
	reportType: number;
	reportDate: Date;
	status: number;
	emailTaskId: string;
	sendingDate: Date;
	fileUploadId: string | null;
	system: string;
	constructor(values: ISalary, system: string) {
		this.id = values.id;
		this.employeeId = values.employeeId;
		this.reportType = values.reportType;
		this.reportDate = new Date(values.reportDate);
		this.status = values.status;
		this.emailTaskId = values.emailTaskId;
		this.sendingDate = new Date(values.sendingDate);
		this.fileUploadId = values.fileUploadId;
		this.system = system;
	}
}
